export default "<button title=\"Disable\" class=\"btn btn-danger\" (click)=\"disable()\">{{'BUTTONS.DISABLE' | translate}}</button>";